// extracted by mini-css-extract-plugin
export default {"navContainer":"uistyles_navContainer__GZASJ","header":"uistyles_header__ry3Fu","header-span":"uistyles_header-span__eybXm","deleteButton":"uistyles_deleteButton__AeGen"};